

































































import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
import Loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";
// api
import { selectAllListRecharge, deleteRecharge } from "@/api/recharge";
import { AddRecharge } from "@/types/api/recharge";
import copy from "@/utils/deepCopy";
import { saveUserProxy } from "@/api/userProxy";
import filterPrice from "@/utils/inputPrice";

@Component
export default class Table extends Mixins(Loading, tablePagination) {
  @Prop() fromDate!: string;
  @Prop() shopName!: string;
  @Prop() phone!: string;
  @Prop() userName!: string;

  private tableData: Array<any> = [];
  mounted() {
    this.getData();
  }

  /**
   * methods
   */
  getData(): void {
    this.showLoading();
    selectAllListRecharge({ deleteStatus: 0 }).then((res: any) => {
      res.data.forEach((e: any) => {
        e.totalAmound = filterPrice(
          (e.giveAmount * 100 + e.chargeAmount * 100) / 100
        );
      });
      this.tableData = res.data;
      this.hideLoading();
    });
  }
  // 删除
  handleDelete(row: AddRecharge) {
    this.$confirm(`是否要删除该方案 ?`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      let id: any = row.id;
      deleteRecharge({
        id: id,
      }).then((res) => {
        this.$message.success("删除成功");
        this.getData();
      });
    });
    
  }
}
